import themeGlobal from './themeGlobal';
import UtilObject from '../utils/UtilObject';
import {
  adminLayoutLightTokens,
  createAdminLayoutComponentTheme,
} from './adminLayoutTheme';
import { authLightTokens } from './authTheme';
import { appLightPalette } from './themePalette';

const lightDisabledComponent = {
  colorBgContainerDisabled: appLightPalette.disabledBg,
  colorTextDisabled: appLightPalette.disabledText,
};

const themeLightConfigLocal = {
  token: {
    ...adminLayoutLightTokens,
    ...authLightTokens,
    colorBgContainerDisabled: appLightPalette.disabledBg,
    colorBorderDisabled: appLightPalette.disabledBorder,
    colorTextDisabled: appLightPalette.disabledText,
  },
  components: {
    ...createAdminLayoutComponentTheme(adminLayoutLightTokens),
    Input: { ...lightDisabledComponent },
    InputNumber: { ...lightDisabledComponent },
    Select: { ...lightDisabledComponent },
    DatePicker: { ...lightDisabledComponent },
  },
};

const themeLightConfig = UtilObject.deepMerge(
  themeGlobal,
  themeLightConfigLocal
);

export default themeLightConfig;
